export default function Dialog (theme: any) {
  return {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[900]
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.default,
          padding: 20
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[900],
          padding: 10
        }
      }
    }
  }
}
